// source: src/common/integration/sorter/sorter.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.integration.sorter.IntegrationSortField', null, global);
goog.exportSymbol('proto.loupe.common.integration.sorter.IntegrationSorter', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.sorter.IntegrationSorter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.integration.sorter.IntegrationSorter.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.integration.sorter.IntegrationSorter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.sorter.IntegrationSorter.displayName = 'proto.loupe.common.integration.sorter.IntegrationSorter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.sorter.IntegrationSortField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.integration.sorter.IntegrationSortField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.sorter.IntegrationSortField.displayName = 'proto.loupe.common.integration.sorter.IntegrationSortField';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.integration.sorter.IntegrationSorter.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.sorter.IntegrationSorter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.sorter.IntegrationSorter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.sorter.IntegrationSorter.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sortFieldsList: jspb.Message.toObjectList(msg.getSortFieldsList(),
    proto.loupe.common.integration.sorter.IntegrationSortField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.sorter.IntegrationSorter}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.sorter.IntegrationSorter;
  return proto.loupe.common.integration.sorter.IntegrationSorter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.sorter.IntegrationSorter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.sorter.IntegrationSorter}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectKey(value);
      break;
    case 2:
      var value = new proto.loupe.common.integration.sorter.IntegrationSortField;
      reader.readMessage(value,proto.loupe.common.integration.sorter.IntegrationSortField.deserializeBinaryFromReader);
      msg.addSortFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.sorter.IntegrationSorter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.sorter.IntegrationSorter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.sorter.IntegrationSorter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSortFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.loupe.common.integration.sorter.IntegrationSortField.serializeBinaryToWriter
    );
  }
};


/**
 * optional string object_key = 1;
 * @return {string}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.getObjectKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.sorter.IntegrationSorter} returns this
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.setObjectKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated IntegrationSortField sort_fields = 2;
 * @return {!Array<!proto.loupe.common.integration.sorter.IntegrationSortField>}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.getSortFieldsList = function() {
  return /** @type{!Array<!proto.loupe.common.integration.sorter.IntegrationSortField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.integration.sorter.IntegrationSortField, 2));
};


/**
 * @param {!Array<!proto.loupe.common.integration.sorter.IntegrationSortField>} value
 * @return {!proto.loupe.common.integration.sorter.IntegrationSorter} returns this
*/
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.setSortFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.loupe.common.integration.sorter.IntegrationSortField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.integration.sorter.IntegrationSortField}
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.addSortFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.loupe.common.integration.sorter.IntegrationSortField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.integration.sorter.IntegrationSorter} returns this
 */
proto.loupe.common.integration.sorter.IntegrationSorter.prototype.clearSortFieldsList = function() {
  return this.setSortFieldsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.sorter.IntegrationSortField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.sorter.IntegrationSortField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.sorter.IntegrationSortField.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    asc: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.sorter.IntegrationSortField}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.sorter.IntegrationSortField;
  return proto.loupe.common.integration.sorter.IntegrationSortField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.sorter.IntegrationSortField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.sorter.IntegrationSortField}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAsc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.sorter.IntegrationSortField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.sorter.IntegrationSortField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.sorter.IntegrationSortField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAsc();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.sorter.IntegrationSortField} returns this
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool asc = 2;
 * @return {boolean}
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.getAsc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loupe.common.integration.sorter.IntegrationSortField} returns this
 */
proto.loupe.common.integration.sorter.IntegrationSortField.prototype.setAsc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.loupe.common.integration.sorter);
